import {TriggerPoint} from '../../generated/types';

const AssistantTriggerPoints: TriggerPoint[] = [
  'assistant_search_result_direct',
  'assistant_search_result_suggested_query',
  'assistant_onboarding',
];

const StartFreshTriggerPoints: TriggerPoint[] = [
  'assistant_search_result_direct',
  'assistant_search_result_suggested_query',
  'assistant_onboarding',
];

const RestartableTriggerPoints: TriggerPoint[] = [
  'assistant_drawer_internal',
  'dashboard_help_menu_contact_support',
];

export function isAssistantTriggerPoint(
  triggerPoint?: TriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    AssistantTriggerPoints.includes(triggerPoint as TriggerPoint)
  );
}

export function isStartFreshTriggerPoint(
  triggerPoint?: TriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    StartFreshTriggerPoints.includes(triggerPoint as TriggerPoint)
  );
}

export function isRestartableTriggerPoint(
  triggerPoint?: TriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    RestartableTriggerPoints.includes(triggerPoint as TriggerPoint)
  );
}
